import React, { useRef, useEffect, useContext } from "react";
import styles from "../entity-calendar.module.scss";
import PropTypes from "prop-types";
import { Navigate } from "react-big-calendar";
import Button from "../../../components/Button";
import SetUpProcessModel from "./SetUpProcessModel";
import { Chip } from "primereact/chip";
import { useSelector } from "react-redux";
import { EntityContext } from "..";

const PREV_ARROW = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
  >
    {" "}
    <path
      d="M6.61296 12.5C6.50997 12.5005 6.40792 12.4804 6.3128 12.4409C6.21767 12.4014 6.13139 12.3433 6.05902 12.2701L0.833131 7.04416C0.686336 6.89718 0.603882 6.69795 0.603882 6.49022C0.603882 6.28249 0.686336 6.08325 0.833131 5.93628L6.05902 0.710385C6.20762 0.57192 6.40416 0.496539 6.60724 0.500122C6.81032 0.503705 7.00408 0.585973 7.1477 0.729594C7.29132 0.873215 7.37359 1.06698 7.37717 1.27005C7.38075 1.47313 7.30537 1.66968 7.16691 1.81827L2.49496 6.49022L7.16691 11.1622C7.3137 11.3091 7.39616 11.5084 7.39616 11.7161C7.39616 11.9238 7.3137 12.1231 7.16691 12.2701C7.09454 12.3433 7.00826 12.4014 6.91313 12.4409C6.81801 12.4804 6.71596 12.5005 6.61296 12.5Z"
      fill="#1F2937"
    />{" "}
  </svg>
);
const NEXT_ARROW = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    {" "}
    <path
      d="M4.38708 13.5C4.28408 13.5005 4.18203 13.4804 4.08691 13.4409C3.99178 13.4014 3.9055 13.3433 3.83313 13.2701C3.68634 13.1231 3.60388 12.9238 3.60388 12.7161C3.60388 12.5084 3.68634 12.3091 3.83313 12.1622L8.50507 7.49022L3.83313 2.81827C3.69467 2.66968 3.61928 2.47313 3.62287 2.27005C3.62645 2.06698 3.70872 1.87322 3.85234 1.72959C3.99596 1.58597 4.18972 1.50371 4.3928 1.50012C4.59588 1.49654 4.79242 1.57192 4.94102 1.71039L10.1669 6.93628C10.3137 7.08325 10.3962 7.28249 10.3962 7.49022C10.3962 7.69795 10.3137 7.89718 10.1669 8.04416L4.94102 13.2701C4.86865 13.3433 4.78237 13.4014 4.68724 13.4409C4.59212 13.4804 4.49007 13.5005 4.38708 13.5Z"
      fill="#1F2937"
    />{" "}
  </svg>
);

function EntityCalendarToolbar({
  label,
  onNavigate,
  loading,
  onWidthCalculated,
  chipData,
  handleRemoveFilter,
}) {
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      let totalWidth = 0;
      Array.from(containerRef.current.children).forEach((child) => {
        totalWidth += child.offsetWidth;
      });
      onWidthCalculated(totalWidth);
    }
  }, []);
  const { role } = useSelector((state) => state.login);
  const { entity, hasOnlyPayrollPlus, isProcessFetch, handleOpenProcessModal } =
    useContext(EntityContext);

  return (
    <div className="entity__calander">
      <div className={styles.toolbar}>
        <h3 className={styles["calendar-title"]}>
          {label}
          {loading && <span className="pi pi-spin pi-spinner" />}
        </h3>
        <div ref={containerRef} className={styles["button-tile"]}>
          {role === "GXM_ADMIN" && (
            <>
              <Button
                onClick={() => {
                  handleOpenProcessModal();
                }}
                label="Set Up Process"
                className={`${styles["set-process-btn"]} ${styles["set-process-btn-disabled"]}`}
                loading={isProcessFetch}
                disabled={
                  !entity?.active_services?.length || hasOnlyPayrollPlus
                }
              />
            </>
          )}
          <Button
            onClick={() => onNavigate(Navigate.PREVIOUS)}
            className={styles.navigate}
          >
            {PREV_ARROW}
          </Button>
          <Button
            onClick={() => onNavigate(Navigate.NEXT)}
            className={styles.navigate}
          >
            {NEXT_ARROW}
          </Button>
        </div>
      </div>
      <div className="flex gap-2 align-items-center">
        {chipData?.length ? `Filters (${chipData?.length})` : null}
        {chipData?.map((data) => (
          <Chip
            key={data.value}
            className={styles.calander__filter__chip}
            label={
              <span className="filter__chip">
                <span>{data.label}</span>
                <span className="cross__icon">
                  <i
                    className="pi pi-times"
                    onClick={() => handleRemoveFilter(data)}
                  />
                </span>
              </span>
            }
            removable={false}
          />
        ))}
      </div>
    </div>
  );
}

EntityCalendarToolbar.propTypes = {
  label: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  view: PropTypes.string.isRequired,
  onView: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default EntityCalendarToolbar;
